import React, { useEffect, useState } from 'react';
import { HashRouter, Switch, Route, Redirect } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import SplashVerseBackground from '../components/new-onboarding/splashverse-background/splashverse-background';
import BackToPreviousStepButton from '../components/new-onboarding/splashverse-back-button/splashverse-back-button'
import { OnboardingStates } from '../constant-data/splashverse-onboarding';
import * as S from '../components/new-onboarding/styles/shared-styles';
import UsePrevious from '../components/common/hooks/usePreviousValue';
import MainHeader from '../components/main-header';
import ScrollToTop from '../utils/scroll-to-top.js';
import { useDispatch, useSelector, shallowEqual} from 'react-redux'
import { setLastStep, initialise } from '../stores/splashverse-onboarding/actions';
import useExtendedLocalStorage from '../components/common/hooks/useExtendedLocalStorage';
import { getNextStep } from '../components/new-onboarding/helper/helper';
import { breakpoints } from '../utils/responsive_utilities';
import useResize from '../components/loggedout/custom-hooks/resize';

const Routes = ({currentStep, currentStepIndex, goToNextHandler, currentUser, students}) => {
  const [isNext, setIsNext] = useState(false);
  const prevIndex = UsePrevious(currentStepIndex);
  const screenHeight = useResize().height;

  useEffect(() => {
    if (typeof(prevIndex) !== 'undefined')
      setIsNext(currentStepIndex > prevIndex);
  }, [currentStepIndex]);

  if(OnboardingStates[currentStep]) {
    const route = OnboardingStates[currentStep].route;
    const $component = OnboardingStates[currentStep].component;
    return (
      <>
        <Route
          path={"/"+route}
          render={() =>
            <S.SplashverseOnboardingContainer isProductPage={["purchase_page"].includes(currentStep)} screenH={screenHeight} fullPageDisplay = {false}>
              <$component
                isNextStep={isNext}
                goToNextHandler={goToNextHandler}
                currentStep={currentStep}
                currentUser = {currentUser}
                students = {students}
              />
            </S.SplashverseOnboardingContainer>
          }
        />
        <Route path="*" render={() => (<Redirect to={"/" + route}/>)}/>
      </>
    )
  }
  return null
}

const SplashVerseOnboardingRoutes = ({ currentUser, students }) => {
  // setting first key as the initial step for the onboarding
  const [currentStepIndex, setCurrentStepIndex] = useState(0);
  const [isLoaded, setLoaded] = useState(false);
  const [currentStep, setCurrentStep] = useState('');
  const [headerTransition, setHeaderTransition] = useState(undefined);
  const [headerExit, setHeaderExit] = useState(false);
  const isMobileLandscape = useMediaQuery({ minWidth: breakpoints.sm, maxWidth: breakpoints.lg - 1, orientation: 'landscape' })

  const dispatch = useDispatch();
  const { store, setValue } = useExtendedLocalStorage('splashverse-onboarding', '');

  const {storeLoaded, onboardingStepSequence} = useSelector(state => {
    return {
      storeLoaded: state.storeLoaded,
      onboardingStepSequence: state.onboardingStepSequence,
    }
  }, shallowEqual);

  const goToNextStep = (currentStep, opt = {}) => {
    if (currentStep !== 'first_step') {
      setCurrentStepIndex(currentStepIndex + 1);
    }
    let nextStep = getNextStep[currentStep](opt);
    setCurrentStep(nextStep);
    let oss = [...onboardingStepSequence];
    oss.push(nextStep);
    setValue('onboardingStepSequence', oss);
    dispatch(setLastStep(oss));
  }

  const goToPreviousStep = () => {
    if (currentStepIndex > 0) {
      setCurrentStepIndex(currentStepIndex - 1);
      let oss = [...onboardingStepSequence];
      oss.pop();
      setCurrentStep(oss[oss.length - 1]);
      setValue('onboardingStepSequence', oss);
      dispatch(setLastStep(oss));
    }
  }

  const getCurrentStep = () => {
    // if the onboarding hasn't started yet
    if (onboardingStepSequence.length === 0) {
      let opt = {}
      goToNextStep('first_step', opt);
    } else {
      // onboarding has started now we need to go to the last step
      setCurrentStepIndex(onboardingStepSequence.length - 1);
      setCurrentStep(onboardingStepSequence[onboardingStepSequence.length - 1]);
    }
  }

  useEffect(() => {
    dispatch(initialise(store));
  },[])

  useEffect(() => {
    if (storeLoaded) {
      // Complete loading.
      setLoaded(true);
    }
  }, [storeLoaded]);

  useEffect(() => {
    if (isLoaded) {
      if (onboardingStepSequence.length === 0) {
        setHeaderTransition(false);
        setTimeout(() => {
          setHeaderTransition(true);
        }, 700)
        setTimeout(() => {
          setHeaderExit(true);
          // going to current onboarding step.
          getCurrentStep();
        }, 1700);
      } else {
        setHeaderTransition(false);
        getCurrentStep();
      }
    }
  }, [isLoaded])

  return (
    <div>
      <SplashVerseBackground currentStepIndex={currentStepIndex}/>
      {isLoaded &&
        <>
        {!["purchase_page"].includes(currentStep) ?
            <React.Fragment>
              { !isMobileLandscape && <MainHeader showLogoutLink={true} showClassCodeLogin={!currentUser} showIconLeft={!currentUser} isSmallHeaderMobileLandscape={true} /> }
              <BackToPreviousStepButton
                currentStepIndex={currentStepIndex}
                goBackHandler={goToPreviousStep}
              />
            </React.Fragment> : null
          }
          <S.SplashverseOnboardingContainer>
            <S.StepHeader showTransition={headerTransition} exit={headerExit}>
              {`Welcome!`}<br/>
              {`Let’s setup SplashLearn for your child`}
            </S.StepHeader>
          </S.SplashverseOnboardingContainer>
          { currentStep &&
            <HashRouter>
              <ScrollToTop>
                <Switch>
                  <Routes
                    currentStep={currentStep}
                    currentStepIndex={currentStepIndex}
                    goToNextHandler={goToNextStep}
                    currentUser= {currentUser}
                    students={students}
                  />
                </Switch>
              </ScrollToTop>
            </HashRouter>
          }
        </>
      }
    </div>
  )
}

export default SplashVerseOnboardingRoutes;

